webpackJsonp([226020273838829],{

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pricingModule = __webpack_require__(252);
	
	var _pricingModule2 = _interopRequireDefault(_pricingModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PricingBox = function PricingBox(p) {
	  return _react2.default.createElement(
	    'div',
	    { className: _pricingModule2.default.pricing__box__panel },
	    _react2.default.createElement(
	      'div',
	      { className: _pricingModule2.default.pricing__box__title__panel },
	      p.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { fontSize: '14px' } },
	      p.isLink === true && _react2.default.createElement(
	        _gatsbyLink2.default,
	        { style: { textDecoration: 'none', color: '#5B5379' }, to: p.linkUrl },
	        p.pricing
	      ),
	      p.isLink === false && p.pricing
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _pricingModule2.default.pricing__box__features },
	      _react2.default.createElement(
	        'ul',
	        { style: {
	            listStyle: 'none',
	            paddingLeft: "2px",
	            paddingRight: "2px"
	          } },
	        p.features.map(function (f, index) {
	          return _react2.default.createElement(
	            'li',
	            { style: { fontSize: '14px' }, key: index },
	            f
	          );
	        })
	      )
	    )
	  );
	};
	var PricingPage = function PricingPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: _pricingModule2.default.pricing__page__panel },
	    _react2.default.createElement(PricingBox, {
	      title: 'Trial',
	      key: '1',
	      isLink: false,
	      linkUrl: "",
	      pricing: 'Free'
	      // description="Get started for free and stay free for serious open-source development."
	      , features: ["Client/Site and Employee Management", "Maximum 5 users for 15 days", "Employee Tracking", "Work Order Management & Escalation", "Basic Service Feedback", "Language Localization"]
	    }),
	    _react2.default.createElement(PricingBox, {
	      title: 'Starter',
	      key: '2',
	      isLink: false,
	      linkUrl: "",
	      pricing: '\u20B9 1000 per user (Monthly)'
	      // description="You are working on private and commercial software projects? Then this is your deal."
	      , features: ["Client/Site and Employee Management", "Maximum 10 users per month", "Employee Tracking", "Work Order Management & Escalation", "Basic Service Feedback", "Language Localization"]
	    }),
	    _react2.default.createElement(PricingBox, {
	      title: 'Professional',
	      key: '3',
	      isLink: true,
	      linkUrl: "/contactus",
	      pricing: 'Contact us for details'
	      // description="For professional software engineers who want to be able to code wherever and whenever they want."
	      , features: ["Client/Site and Employee Management", "Unlimited users per month", "Employee Tracking", "Work Order Management & Escalation", "Basic Service Feedback", "Language Localization", "Asset and Parts Management", "Customized Feedback"]
	    })
	  );
	};
	
	exports.default = PricingPage;
	module.exports = exports['default'];

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pricing__page__panel":"src-pages----pricing-module---pricing__page__panel---2wbyt","pricing__box__panel":"src-pages----pricing-module---pricing__box__panel---1SFhU","pricing__box__title__panel":"src-pages----pricing-module---pricing__box__title__panel---AHexg","pricing__box__features":"src-pages----pricing-module---pricing__box__features---3otBf","pricing__btn":"src-pages----pricing-module---pricing__btn---_Zy2w","pricing-page":"src-pages----pricing-module---pricing-page---2pybX","simple-pricing":"src-pages----pricing-module---simple-pricing---20Y5a","title":"src-pages----pricing-module---title---jGiVh","pricing-switch":"src-pages----pricing-module---pricing-switch---31R_9","price-thumb":"src-pages----pricing-module---price-thumb---1PONU","what-get":"src-pages----pricing-module---what-get---37jW_","item":"src-pages----pricing-module---item---1mxMI","check":"src-pages----pricing-module---check---3f4ES","info":"src-pages----pricing-module---info---2jV-c","special-offer":"src-pages----pricing-module---special-offer---3BL7i"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-js-4e4209aaacb28f406df7.js